import React from 'react'
import ListCreatedVirtualClassrooms from '../common'

const ListPlannedPage = () => <ListCreatedVirtualClassrooms type="planned" />

ListPlannedPage.propTypes = {}

export default ListPlannedPage
